import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, AlertTriangle, Lock, CheckCircle } from 'lucide-react';
import { useModals } from '../components/Layout';

const Security = () => {
    const { setIsAuditModalOpen } = useModals();

    return (
        <div className="landing-page">
            <main className="policy-content" style={{ paddingTop: '120px', paddingBottom: '100px', maxWidth: '800px', margin: '0 auto', paddingLeft: '7.6923%', paddingRight: '7.6923%' }}>
                <Link to="/" className="back-link" style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--brand-primary)', textDecoration: 'none', marginBottom: '40px' }}>
                    <ArrowLeft size={20} />
                    Back to Home
                </Link>

                <h1 className="section-title" style={{ textAlign: 'left', marginBottom: '40px' }}>AI Security & Compliance</h1>

                <div className="security-intro" style={{ marginBottom: '60px' }}>
                    <p className="section-description" style={{ textAlign: 'left', margin: '0 0 30px 0' }}>
                        Adjactive is dedicated to securing the future of AI. We provide specialized red teaming and compliance services designed specifically for the unique vulnerabilities of machine learning systems.
                    </p>
                </div>

                <section className="security-section" style={{ marginBottom: '60px' }}>
                    <h2 style={{ color: 'var(--brand-primary)', marginBottom: '24px', fontSize: '28px' }}>AI Red Teaming</h2>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6', marginBottom: '20px' }}>
                        Our red teaming exercises go beyond traditional penetration testing. We simulate sophisticated adversarial attacks to identify how your AI systems could be manipulated, bypassed, or exploited.
                    </p>
                    <div className="security-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px', marginTop: '30px' }}>
                        <div className="security-card" style={{ background: 'var(--bg-secondary)', padding: '24px', border: '1px solid var(--border-subtle)' }}>
                            <AlertTriangle className="capability-icon" size={32} style={{ marginBottom: '16px' }} />
                            <h3 style={{ marginBottom: '12px' }}>Adversarial Attacks</h3>
                            <p style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>Testing against prompt injection, jailbreaking, and indirect prompt injection attacks that can hijack model intent.</p>
                        </div>
                        <div className="security-card" style={{ background: 'var(--bg-secondary)', padding: '24px', border: '1px solid var(--border-subtle)' }}>
                            <Lock className="capability-icon" size={32} style={{ marginBottom: '16px' }} />
                            <h3 style={{ marginBottom: '12px' }}>Model Integrity</h3>
                            <p style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>Evaluating resistance to model extraction, data poisoning, and membership inference attacks.</p>
                        </div>
                    </div>
                </section>

                <section className="security-section" style={{ marginBottom: '60px' }}>
                    <h2 style={{ color: 'var(--brand-primary)', marginBottom: '24px', fontSize: '28px' }}>Global Compliance</h2>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6', marginBottom: '20px' }}>
                        Navigate the complex landscape of AI regulation with confidence. We help ensure your AI deployments meet the highest standards of safety and legality.
                    </p>
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                        {[
                            { title: 'EU AI Act Alignment', desc: 'Comprehensive readiness assessments for high-risk AI systems under the European Union AI Act.' },
                            { title: 'NIST AI RMF', desc: 'Implementation of the NIST Artificial Intelligence Risk Management Framework.' },
                            { title: 'ISO/IEC 42001', desc: 'Guidance on establishing, implementing, and maintaining an AI management system.' }
                        ].map((item, idx) => (
                            <li key={idx} style={{ display: 'flex', gap: '16px', marginBottom: '20px', padding: '16px', background: 'rgba(255,255,255,0.03)' }}>
                                <CheckCircle size={24} style={{ color: 'var(--brand-primary)', flexShrink: 0 }} />
                                <div>
                                    <h4 style={{ marginBottom: '4px' }}>{item.title}</h4>
                                    <p style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>{item.desc}</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                </section>

                <section className="security-section">
                    <h2 style={{ color: 'var(--brand-primary)', marginBottom: '24px', fontSize: '28px' }}>Continuous Assurance</h2>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                        AI security isn't a one-time event. Adjactive provides ongoing monitoring and regular re-assessments as your models evolve and new threat patterns emerge in the wild.
                    </p>
                </section>
            </main>
        </div>
    );
};

export default Security;
